import Typography from "@pagepro-monorepo/ui/lib/components/styles/Typography";

import Image from "@components/atoms/Image";

import { TestimonialsBulletProps } from "./types";
import * as Styled from "./styles";
import { TESTIMONIAL_BULLET_AVATAR_SIZE } from "./consts";

const TestimonialsBullet: React.FC<TestimonialsBulletProps> = ({
  name,
  description,
  avatar,
  onClick,
  ...rest
}) => {
  const content = (
    <>
      {avatar && (
        <Styled.Media>
          <Image
            {...avatar}
            height={TESTIMONIAL_BULLET_AVATAR_SIZE}
            width={TESTIMONIAL_BULLET_AVATAR_SIZE}
            style={{
              objectFit: "contain",
              objectPosition: "center"
            }}
          />
        </Styled.Media>
      )}
      <Styled.Details>
        {name ? (
          <Typography variant="body8" as="span">
            {name}
          </Typography>
        ) : null}
        {description ? (
          <Typography fontSize=".75rem" as="span" fontWeight="light">
            {description}
          </Typography>
        ) : null}
      </Styled.Details>
    </>
  );

  return onClick ? (
    <Styled.Wrapper type="button" {...{ onClick, ...rest }}>
      {content}
    </Styled.Wrapper>
  ) : (
    <Styled.WrapperDiv {...rest}>{content}</Styled.WrapperDiv>
  );
};

export default TestimonialsBullet;
